import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efa8dd5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-fullscreen"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderNav = _resolveComponent("HeaderNav")!
  const _component_Container = _resolveComponent("Container")!
  const _component_MenuMobile = _resolveComponent("MenuMobile")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "pe-layout-mobile-wrapper",
    "data-fullscreen": _ctx.isFullscreen
  }, [
    _withDirectives(_createVNode(_component_HeaderNav, { fixed: "" }, null, 512), [
      [_vShow, !_ctx.isFullscreen]
    ]),
    _createVNode(_component_Container, {
      spaceHeader: 
        _ctx.isFullscreen ? '0px' : 'calc(var(--header-height, 0px) + var(--status-bar-height, 0px))'
      ,
      spaceFooter: _ctx.showTabbar ? '50px' : ''
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["spaceHeader", "spaceFooter"]),
    (_ctx.showTabbar)
      ? _withDirectives((_openBlock(), _createBlock(_component_Footer, {
          key: 0,
          fixed: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MenuMobile, {
              list: _ctx.tabbarList()
            }, null, 8, ["list"])
          ]),
          _: 1
        }, 512)), [
          [_vShow, !_ctx.isFullscreen]
        ])
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}